import { IFinishingStage } from 'types';

export const FINISHING_STAGES: IFinishingStage = {
  FINE: 'Чистовая',
  FURNISHING: 'Меблировка',
  FURNITURE_ASSEMBLING: 'Сборка мебели',
  ROUGH: 'Черновая',
};
